import { render, staticRenderFns } from "./scanQr.vue?vue&type=template&id=37fcc9bd&scoped=true&"
import script from "./scanQr.vue?vue&type=script&lang=js&"
export * from "./scanQr.vue?vue&type=script&lang=js&"
import style0 from "./scanQr.vue?vue&type=style&index=0&id=37fcc9bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fcc9bd",
  null
  
)

export default component.exports